import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { FontVariant } from '../../utils/types/typography';
var baseClassName = 'AccordionHeader';
var Icon = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'icon')
}).withConfig({
  componentId: "sc-1dtjsgt-0"
})(function () {
  return css(["display:inline-flex;padding-left:8px;"]);
});
var Label = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'label')
}).withConfig({
  componentId: "sc-1dtjsgt-1"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ""], theme.typography.font[FontVariant.ButtonSm]);
});
var Header = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-1dtjsgt-2"
})(function (_ref2) {
  var theme = _ref2.theme,
    fullWidth = _ref2.fullWidth;
  return css(["display:inline-flex;align-items:center;justify-content:space-between;box-sizing:border-box;cursor:pointer;width:", ";color:", ";user-select:none;"], fullWidth ? '100%' : 'auto', theme.palette[PColor.LinkPrimary]);
});
var Wrapper = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'wrapper')
}).withConfig({
  componentId: "sc-1dtjsgt-3"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["color:", ";"], theme.palette[PColor.LinkPrimary]);
});
var Styled = applyDisplayNames({
  Header: Header,
  Wrapper: Wrapper,
  Icon: Icon,
  Label: Label
});
export default Styled;